import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import qs from "qs";
import {
  clearAnalyticsPlaceHolders,
  getAnalyticsPlaceHolders
} from "../../actions/placeHoldersActions";
import { DEAL_RESULTS_ANALYTICS_PHASE } from "../../constants/general";
import { Grid, Ref } from "semantic-ui-react";
import * as dealsActions from "../../actions/dealsActions";
import DealsGroup from "../../components/DealsGroup";
import DealDetails from "../../components/DealDetails";
import RoomDetailsAndAmenities from "../../components/RoomDetailsAndAmenities";
import { isRTL } from "../../reducers";
import * as roomResultsActions from "../../actions/roomResultsActions";
import * as paxActions from "../../actions/paxActions";
import * as addonsActions from "../../actions/addonsActions";
import { priceNormelizer } from "../../helpers/tags";
import { NoResultsPage, Fader, AnimatedSwitch } from "../../components/common";
import DealThumbNailCustom from "../../components/DealThumbNailCustom";
import styles from "./styles.less";

class DealsResults extends Component {
  state = {
    title: null,
    subTitle: null,

    // for scrolling logic (we need to scroll when the image loaded)
    selectedDealImageLoaded: false
  };

  async componentDidMount() {
    const {
      selectedDealId,
      selectedHotelId,
      actions,
      discountClubConfig,
      lang
    } = this.props;
    this.props.onLoad();
    const reqObj = {
      clubCode: discountClubConfig && discountClubConfig.ClubCode,
      selectedHotelId: null,
      lang
    };
    await actions.getDealsResult(reqObj);

    if (selectedDealId) {
      const { deals } = this.props;
      const selectedDeal = deals.find(
        deal =>
          deal.id &&
          deal.id.toString() == selectedDealId &&
          deal.hotelId == selectedHotelId
      );
      actions.getDealDetails(selectedDeal);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const { onLoad, selectedDealId, actions, deals } = this.props;
    //remove unusable code
    const { selectedDealImageLoaded } = this.state;
    if (
      selectedDealImageLoaded &&
      prevState.selectedDealImageLoaded !== selectedDealImageLoaded
    ) {
      onLoad();
    }
    //end remove
    if (prevProps.selectedDealId !== selectedDealId) {
      if (selectedDealId) {
        const selectedDeal = deals.find(
          deal => deal.id && deal.id.toString() == selectedDealId
        );
        //Get deal data
        await actions.getDealDetails(selectedDeal);
      }
      //reset previous search
      actions.resetSelection();
      actions.resetSelectedPaxIndex();
      actions.resetPaxList();
      actions.changeDisplayRoom(null);
      actions.resetDealSearchResult();
    }
  }

  /**
   * Get analytics code from server and append it to #page-analytics-wrapper element ( append action include the execution ).
   * Generate the code with the data stored until this phase ( ex, no masterid )
   */
  getAnalyticsPlaceHolders = deal => {
    const { actions } = this.props;
    let checkin = moment(deal.startDate);
    checkin = checkin.format("DD.MM.YYYY");
    let checkout = moment(deal.endDate);
    checkout = checkout.format("DD.MM.YYYY");
    const postObject = {
      Phase: DEAL_RESULTS_ANALYTICS_PHASE,
      Currency: deal.currencyCode,
      HotelId: deal.hotelId,
      HotelName: deal.hotelName,
      CheckInDate: checkin,
      CheckoutDate: checkout,
      DealId: deal.id
    };
    actions.getAnalyticsPlaceHolders(postObject);
  };

  //remove unusable code
  onSelectedDealImageLoaded = () => {
    this.setState({ selectedDealImageLoaded: true });
  };
  //end remove

  onRateSelection = ({ ...selectedRateParams }) => {
    const { onRateSelection, dealSearchResults } = this.props;

    // dispatch global event of roomselected
    const event = new CustomEvent("__be_dealSelected", {
      detail: {
        roomId: selectedRateParams.roomId,
        dealId: selectedRateParams.dealId
      }
    });
    window.dispatchEvent(event);

    onRateSelection({
      ...selectedRateParams,
      dealSearchResults
    });
  };

  onRateReadMore = ({ rateId, roomId }) => {
    const { onRateReadMore } = this.props;
    onRateReadMore({ rateId, roomId, render: this.renderRoomDetails });
  };

  renderRoomDetails = room => {
    const { titles, isRtl, ShowCancellationPolicy, isMobileView } = this.props;
    return (
      <RoomDetailsAndAmenities
        room={room}
        titles={titles}
        isRtl={isRtl}
        ShowCancellationPolicy={ShowCancellationPolicy}
        isMobileView={isMobileView}
      />
    );
  };

  /// remove previous selection key and add the new selection key to query.
  /// push the updated data to browser histoy to change current route
  onDealSelect = (dealId, hotelId) => {
    const { actions } = this.props;
    const getDealRouteWithQuery = id => {
      const { routing } = this.props;
      let resultPathname = "/deals";
      const currentQuery = qs.parse(routing.location.search, {
        ignoreQueryPrefix: true
      });
      currentQuery.selectedHotelId = hotelId;
      currentQuery.selectedCityCode = undefined;
      currentQuery.selectedRegionId = undefined;
      if (
        currentQuery.selectedDealId != null &&
        currentQuery.selectedDealId == id
      ) {
        currentQuery.selectedDealId = undefined;
      } else {
        resultPathname += "/deal";
        currentQuery.selectedDealId = id;
      }

      return {
        pathname: resultPathname,
        search: qs.stringify(currentQuery, { addQueryPrefix: true })
      };
    };

    actions.push(getDealRouteWithQuery(dealId));
    actions.resetDealMode();
  };

  performDealSearch = async dealData => {
    const {
      actions,
      showMessage,
      enableAddonsPopUp,
      enableAddonsRegistration
    } = this.props;
    try {
      await actions.getDealSearch(dealData);
      const {
        SelectedHotelID,
        CheckIn,
        CheckOut,
        Lang,
        PromoCode,
        Pax
      } = dealData.searchData;
      const addonReqObj = {
        hotelId: SelectedHotelID,
        fromDate: CheckIn,
        toDate: CheckOut,
        lang: Lang,
        promoCode: PromoCode,
        pax: Pax
      };
      if (enableAddonsPopUp || enableAddonsRegistration) {
        await actions.getAddonsResult(addonReqObj); // pause next execution
      }
    } catch (err) {
      showMessage("An error occoured, Please try again later", "error");
    }
  };

  normalizeDealsToProduct = deal => {
    const product = {
      id: deal.id,
      name: deal.name,
      lowestPrice: deal.totalPrice,
      oldPrice: deal.oldPrice,
      simpleClubTotalPrice: deal.simpleClubTotalPrice,
      currency: deal.currency,
      currencyCode: deal.currencyCode,
      description: deal.description,
      images: deal.image,
      defaultImage: deal.image,
      hotelName: deal.hotelName,
      hotelId: deal.hotelId,
      startDate: moment(deal.startDate).format("DD/MM/YY"),
      endDate: moment(deal.endDate).format("DD/MM/YY")
    };
    return product;
  };

  filterByPlans = rooms => {
    const { planFilter } = this.props;
    if (planFilter && planFilter.length > 0) {
      const roomsAfterFilter = [];
      rooms.forEach(element => {
        const rates = [];
        element &&
          element.rates &&
          element.rates.forEach(rate => {
            let index = planFilter.findIndex(
              r => r.planCode == rate.planCode && r.planName == rate.planName
            );
            if (index > -1) {
              rates.push(rate);
            }
          });
        if (rates && rates.length > 0) {
          roomsAfterFilter.push({
            ...element,
            rates: [...rates]
          });
        }
      });
      return roomsAfterFilter;
    } else {
      return rooms;
    }
  };

  createPrice = (price, currency) => {
    const priceStr = priceNormelizer`${price} ${currency}`;
    return <div>{priceStr}</div>;
  };

  renderDealsMarkUp = (product, onDealClick) => {
    const { titles, isIE, discountClubConfig, clubUserLoggedIn } = this.props;
    const showClubPrices =
      discountClubConfig && discountClubConfig.Active && !clubUserLoggedIn;
    return (
      <DealThumbNailCustom
        titles={titles}
        isIE={isIE}
        discountClubConfig={discountClubConfig}
        clubUserLoggedIn={clubUserLoggedIn}
        showClubPrices={showClubPrices}
        product={product}
        onClick={onDealClick}
        isDeal={true}
      />
    );
  };

  renderImageMarkup = product => {
    //const { titles } = this.props;
    return <div className={styles.dealHotel}>{product.hotelName}</div>;
  };

  showSimpleClubLoginModal = () => {
    const { showSimpleClubLoginModal } = this.props;
    showSimpleClubLoginModal();
  };

  filterByHotel = deals => {
    const { hotelFilter } = this.props;
    if (hotelFilter && hotelFilter.length > 0) {
      const dealsAfterFilter = [];
      deals &&
        deals.forEach(deal => {
          let index = hotelFilter.findIndex(
            r => r.hotelId == deal.hotelId && r.hotelName == deal.hotelName
          );
          if (index > -1) {
            dealsAfterFilter.push(deal);
          }
        });
      return dealsAfterFilter;
    } else {
      return deals;
    }
  };

  filterByPrice = deals => {
    const { minPriceRangeFilter, maxPriceRangeFilter } = this.props;
    if (minPriceRangeFilter > 0 || maxPriceRangeFilter > 0) {
      const dealsAfterFilter = [];
      deals.forEach(deal => {
        let isInRange =
          Math.round(deal.totalPricee) >= minPriceRangeFilter &&
          Math.round(deal.totalPrice) <= maxPriceRangeFilter;
        if (isInRange) {
          dealsAfterFilter.push(deal);
        }
      });
      return dealsAfterFilter;
    } else {
      return deals;
    }
  };

  filterDeals = deals => {
    const filteredByHotel = this.filterByHotel(deals);
    const filteredByPrice = this.filterByPrice(filteredByHotel);
    return filteredByPrice;
  };

  renderDealsGroup = () => {
    const {
      isRtl,
      titles,
      isMobileView,
      deals,
      lang,
      routing,
      rooms,
      dealSearchPerformed,
      isDealMode,
      isfetchingRooms,
      renderLoader,
      selectedDealId,
      handleSelectedDealRef,
      clubUserLoggedIn,
      discountClubConfig,
      showClubPrices,
      isIos,
      isIE,
      lastMinuteDaysDeal,
      showHotDeal,
      onLoad
    } = this.props;
    const filteredDeals = this.filterDeals(deals);
    return (
      <DealsGroup
        key={deals && deals.length > 0}
        selectedDealId={selectedDealId}
        handleSelectedDealRef={handleSelectedDealRef}
        onThumbnailImageLoad={this.onSelectedDealImageLoaded}
        isRtl={isRtl}
        isMobileView={isMobileView}
        titles={titles}
        onDealClick={this.onDealSelect}
        results={filteredDeals}
        normalizeResult={this.normalizeDealsToProduct}
        isDeals={true}
        renderMarkup={this.renderDealsMarkUp}
        lang={lang}
        routing={routing}
        performDealSearch={this.performDealSearch}
        rooms={rooms}
        dealSearchPerformed={dealSearchPerformed}
        isDealMode={isDealMode}
        renderImageMarkup={this.renderImageMarkup}
        isFetchingDealSearchResults={isfetchingRooms}
        renderLoader={renderLoader}
        clubUserLoggedIn={clubUserLoggedIn}
        isClubActive={discountClubConfig && discountClubConfig.Active}
        showClubPrices={showClubPrices}
        lastMinuteDaysDeal={lastMinuteDaysDeal}
        showHotDeal={showHotDeal}
        isIos={isIos}
        isIE={isIE}
        onLoad={onLoad}
      />
    );
  };

  renderDealDetails = () => {
    const {
      isRtl,
      onLoad,
      titles,
      isMobileView,
      deal,
      lang,
      actions,
      routing,
      selectedDealId,
      dealSearchResults,
      selectedPaxId,
      clubUserLoggedIn,
      discountClubConfig,
      redirectFormRef,
      ShowCancellationPolicy,
      isFetchingDealsSearchResults,
      showClubPrices,
      renderLoader,
      showAvailability,
      onShowRoomGalleryPopUp,
      isDealAnimationActive,
      isDealMode,
      handleDealRatesGroupRef,
      onShowDealExtraDetailsClick,
      onDealRatesClick,
      domainUrl,
      placeHolders,
      isIos,
      isIE,
      minPriceRangeFilter,
      maxPriceRangeFilter,
      planFilter,
      showPricePerNightThumb,
      displayPriceWithoutTaxes
    } = this.props;

    return (
      <Fader
        uKey={selectedPaxId != null ? selectedPaxId.toString() : ""}
        className={styles.dealResultWrapper}
      >
        <DealDetails
          key={deal && deal.id}
          onLoad={onLoad}
          selectedDealId={selectedDealId}
          deal={deal}
          isRtl={isRtl}
          isMobileView={isMobileView}
          titles={titles}
          isDeals={true}
          renderMarkup={this.renderDealsMarkUp}
          renderLoader={renderLoader}
          lang={lang}
          routing={routing}
          createPrice={this.createPrice}
          dealSearchResults={dealSearchResults}
          performDealSearch={this.performDealSearch}
          selectedPaxId={selectedPaxId}
          onRateSelection={this.onRateSelection}
          isClubActive={discountClubConfig && discountClubConfig.Active}
          showSimpleClubLoginModal={this.showSimpleClubLoginModal}
          redirectFormRef={redirectFormRef}
          ShowCancellationPolicy={ShowCancellationPolicy}
          showClubPrices={showClubPrices}
          isFetchingDealsSearchResults={isFetchingDealsSearchResults}
          showAvailability={showAvailability}
          onRateReadMore={this.onRateReadMore}
          isDealAnimationActive={isDealAnimationActive}
          onShowRoomGalleryPopUp={onShowRoomGalleryPopUp}
          onShowDealExtraDetailsClick={onShowDealExtraDetailsClick}
          isDealMode={isDealMode}
          domainUrl={domainUrl}
          clubUserLoggedIn={clubUserLoggedIn}
          clubPercentageDiscount={
            discountClubConfig && discountClubConfig.Percentage
          }
          isIos={isIos}
          isIE={isIE}
          handleDealRatesGroupRef={handleDealRatesGroupRef}
          onDealRatesClick={onDealRatesClick}
          resetDealResults={actions.resetDealSearchResult}
          getAnalyticsPlaceHolders={this.getAnalyticsPlaceHolders}
          clearAnalyticsPlaceHolders={actions.clearAnalyticsPlaceHolders}
          placeHolders={placeHolders}
          minPriceRangeFilter={minPriceRangeFilter}
          maxPriceRangeFilter={maxPriceRangeFilter}
          planFilter={planFilter}
          showPricePerNightThumb={showPricePerNightThumb}
          displayPriceWithoutTaxes={displayPriceWithoutTaxes}
        />
      </Fader>
    );
  };

  renderNoResultsPage = () => {
    const { titles, hotelData, isRtl } = this.props;
    return (
      <Grid centered textAlign="center" stretched>
        <Grid.Column verticalAlign="middle" stretched>
          <NoResultsPage hotelData={hotelData} titles={titles} isRtl={isRtl} />
        </Grid.Column>
      </Grid>
    );
  };

  render() {
    const {
      isFetchingDealsResults,
      renderLoader,
      hasDealResults,
      handleDealsResultsRef,
      routing
    } = this.props;
    return (
      <Grid centered textAlign="center" stretched>
        <Ref innerRef={handleDealsResultsRef}>
          <React.Fragment>
            {/* while fetching data - render only loader */}
            {isFetchingDealsResults && renderLoader(true)}

            {/* if result is empty - render no results view*/}
            {!isFetchingDealsResults &&
              !hasDealResults &&
              this.renderNoResultsPage()}

            {/* if result is exist - render relavent route*/}
            {!isFetchingDealsResults &&
              hasDealResults && (
                <AnimatedSwitch
                  location={routing.location}
                  timeout={450}
                  className="switch-wrapper"
                >
                  <Route path="/deals/deal" render={this.renderDealDetails} />
                  <Route path="/deals" render={this.renderDealsGroup} />
                </AnimatedSwitch>
              )}
          </React.Fragment>
        </Ref>
      </Grid>
    );
  }
}

DealsResults.defaultProps = {
  onLoad: () => {}
};

DealsResults.propTypes = {
  lang: PropTypes.string,
  titles: PropTypes.object,
  isMobileView: PropTypes.bool,
  isRtl: PropTypes.bool,
  isIE: PropTypes.bool,
  isIos: PropTypes.bool,
  actions: PropTypes.object,
  routing: PropTypes.object,
  renderLoader: PropTypes.func,
  deals: PropTypes.array,
  deal: PropTypes.object,
  isFetchingDealsResults: PropTypes.bool,
  dealSearchPerformed: PropTypes.bool,
  rooms: PropTypes.object,
  isDealMode: PropTypes.bool,
  isfetchingRooms: PropTypes.bool,
  selectedDealId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleSelectedDealRef: PropTypes.func,
  onLoad: PropTypes.func,
  discountClubConfig: PropTypes.object,
  dealSearchResults: PropTypes.array,
  selectedPaxId: PropTypes.number,
  onRateSelection: PropTypes.func,
  clubUserLoggedIn: PropTypes.bool,
  showSimpleClubLoginModal: PropTypes.func,
  onRateReadMore: PropTypes.func,
  ShowCancellationPolicy: PropTypes.bool,
  redirectFormRef: PropTypes.func,
  showClubPrices: PropTypes.bool,
  isFetchingDealsSearchResults: PropTypes.bool,
  showAvailability: PropTypes.bool,
  isDealAnimationActive: PropTypes.bool,
  onShowRoomGalleryPopUp: PropTypes.func,
  handleDealRatesGroupRef: PropTypes.func,
  handleDealsResultsRef: PropTypes.func,
  onDealRatesClick: PropTypes.func,
  hasDealResults: PropTypes.bool,
  hotelData: PropTypes.object,
  showMessage: PropTypes.func,
  onShowDealExtraDetailsClick: PropTypes.func,
  showHotDeal: PropTypes.bool,
  lastMinuteDaysDeal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  domainUrl: PropTypes.string,
  placeHolders: PropTypes.array,
  planFilter: PropTypes.array,
  hotelFilter: PropTypes.array,
  maxPriceRangeFilter: PropTypes.number,
  minPriceRangeFilter: PropTypes.number,
  enableAddonsPopUp: PropTypes.bool,
  enableAddonsRegistration: PropTypes.bool,
  showPricePerNightThumb: PropTypes.bool,
  displayPriceWithoutTaxes: PropTypes.bool
};

DealsResults.defaultProps = {
  isIE: false
};

function mapStateToProps(store) {
  const state = {
    lang: store.lang,
    titles: store.titles,
    isMobileView: store.isMobileView,
    isRtl: isRTL(store),
    isIE: store.isIE,
    isIos: store.isIos,
    isFetchingDealsResults: store.isFetchingDealsResults,
    routing: store.routing,
    deals: store.deals,
    deal: store.deal,
    rooms: store.rooms,
    dealSearchPerformed: store.dealSearchPerformed,
    isDealMode: store.isDealMode,
    isfetchingRooms: store.isfetchingRooms,
    selectedDealId: store.selectedDealId,
    selectedHotelId: store.selectedHotelId,
    discountClubConfig: store.discountClubConfig,
    dealSearchResults: store.dealSearchResults,
    selectedPaxId: store.selectedPaxId,
    clubUserLoggedIn: store.clubUserLoggedIn,
    ShowCancellationPolicy: store.ShowCancellationPolicy,
    isFetchingDealsSearchResults: store.isFetchingDealsSearchResults,
    showAvailability: store.showAvailability,
    isDealAnimationActive: store.isDealAnimationActive,
    selectedAddonsGroup: store.selectedAddonsGroup,
    hasDealResults: store.hasDealResults,
    hotelData: store.hotelData,
    showHotDeal: store.showHotDeal,
    lastMinuteDaysDeal: store.lastMinuteDaysDeal,
    domainUrl: store.domainUrl,
    placeHolders: store.placeHolders,
    planFilter: store.planFilter,
    hotelFilter: store.hotelFilter,
    maxPriceRangeFilter: store.maxPriceRangeFilter,
    minPriceRangeFilter: store.minPriceRangeFilter,
    enableAddonsPopUp: store.enableAddonsPopUp,
    enableAddonsRegistration: store.enableAddonsRegistration,
    showPricePerNightThumb: store.showPricePerNightThumb,
    displayPriceWithoutTaxes: store.displayPriceWithoutTaxes
  };
  return state;
}

function mapDispatchToProps(dispatch) {
  const combinedActions = {
    ...dealsActions,
    ...roomResultsActions,
    ...paxActions,
    ...addonsActions,
    clearAnalyticsPlaceHolders,
    getAnalyticsPlaceHolders,
    push
  };
  return {
    actions: bindActionCreators(combinedActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DealsResults);



// WEBPACK FOOTER //
// ./src/containers/DealsResults/DealsResults.js